// extracted by mini-css-extract-plugin
export var o_links = "links-module--o_links--62b57";
export var o_links__icon = "links-module--o_links__icon--b28c9";
export var o_links__label = "links-module--o_links__label--00b21";
export var o_links__link = "links-module--o_links__link--625fc";